import { useState, useEffect, useMemo } from 'react';

// Process-lifetime fetch cache: cacheKey -> { data: [], loading: bool, error: any }
// Cache key is `${principalURN}:${threadURN}` to scope per thread.
const decisionCache = new Map();

export function useDecisions({ principalURN, threadURN }) {
  const cacheKey = principalURN ? `${principalURN}:${threadURN || ''}` : null;
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!principalURN) return;
    if (decisionCache.has(cacheKey)) return;
    decisionCache.set(cacheKey, { data: [], loading: true, error: null });

    const params = new URLSearchParams({
      entity_type: 'memory',
      kind: 'decision',
      limit: '50',
    });
    if (principalURN) params.set('subject', principalURN);
    if (threadURN) params.set('fromThread', threadURN);

    window.fetch(`/api/memory?${params}`)
      .then(r => r.json())
      .then(d => {
        decisionCache.set(cacheKey, { data: d.memories || d.items || [], loading: false, error: null });
        setTick(t => t + 1);
      })
      .catch(err => {
        decisionCache.set(cacheKey, { data: [], loading: false, error: err });
        setTick(t => t + 1);
      });
  }, [cacheKey]);

  return useMemo(() => {
    const entry = cacheKey ? decisionCache.get(cacheKey) : null;
    const decisions = entry?.data || [];
    const loading = entry?.loading ?? (cacheKey ? !entry : false);
    return { decisions, loading, approximate: false };
  }, [cacheKey, tick]);
}
